"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
var react_1 = __importDefault(require("react"));
var Layout_module_scss_1 = __importDefault(require("./Layout.module.scss"));
var BurgerMenu_1 = require("../burgerMenu/BurgerMenu");
var Footer_1 = require("../footer/Footer");
var Header_1 = require("../header/Header");
var InitialProvider_1 = require("../../hoc/InitialProvider");
var ModalBenefit_1 = require("../modalBenefit/ModalBenefit");
var ModalCallback_1 = require("../modalCallback/ModalCallback");
var ModalCredit_1 = require("../modalCredit/ModalCredit");
var ModalEquipment_1 = require("../modalEquipment/ModalEquipment");
var ModalExchange_1 = require("../modalExchange/ModalExchange");
var ModalReport_1 = require("../modalReport/ModalReport");
var ModalSelectCar_1 = require("../modalSelectCar/ModalSelectCar");
var react_router_dom_1 = require("react-router-dom");
var ModelCatalogOrder_1 = require("../modalCatalogOrder/ModelCatalogOrder");
var Layout = function () {
    return (react_1.default.createElement(InitialProvider_1.InitialProvider, null,
        react_1.default.createElement("div", { className: Layout_module_scss_1.default.body_inner },
            react_1.default.createElement(Header_1.Header, null),
            react_1.default.createElement("main", { className: Layout_module_scss_1.default.main },
                react_1.default.createElement(react_router_dom_1.Outlet, null)),
            react_1.default.createElement(Footer_1.Footer, null),
            react_1.default.createElement(BurgerMenu_1.BurgerMenu, null),
            react_1.default.createElement(ModalBenefit_1.ModalBenefit, null),
            react_1.default.createElement(ModalCallback_1.ModalCallback, null),
            react_1.default.createElement(ModelCatalogOrder_1.ModalCatalogOrder, null),
            react_1.default.createElement(ModalCredit_1.ModalCredit, null),
            react_1.default.createElement(ModalEquipment_1.ModalEquipment, null),
            react_1.default.createElement(ModalExchange_1.ModalExchange, null),
            react_1.default.createElement(ModalReport_1.ModalReport, null),
            react_1.default.createElement(ModalSelectCar_1.ModalSelectCar, null))));
};
exports.Layout = Layout;
